import { tokenState } from '../state/apolloVars';
import { clearSession } from './authFlowLink';
import { getHeaders } from './fetchHeaders';
import { refetchTokenSerially } from './refetchTokenSerially';
import * as settings from '../state/preferences';
import {
  analyticsService,
  POSTHOG_EVENT_ACTIONS,
  POSTHOG_EVENT_DATA,
} from '../analytics/AnalyticsService';

type JSONValue = string | number | boolean | JSONObject | JSONArray;
interface JSONObject {
  [x: string]: JSONValue;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface JSONArray extends Array<JSONValue> {}

export async function makeRequest(url: string, input: JSONObject) {
  try {
    const body = JSON.stringify(input);
    const headers = await getHeaders();
    const response = await fetch(url, {
      method: 'POST',
      body: body,
      headers: headers,
    });
    return await response.json();
  } catch (e) {
    console.log(e);
    if ((tokenState().expiredDate as number) < Date.now()) {
      refetchTokenSerially()
        .catch(error => {
          // logout user
          console.error('FAIL TO REFRESH USER TOKEN', error);
          clearSession();
          tokenState({});
        })
        .finally(async () => {
          const session = await settings.getSession();
          analyticsService.capture(
            POSTHOG_EVENT_ACTIONS.TOKEN_REFRESH_OR_EXPIRED,
            {
              orgId: session?.currentOrganization?.id,
              orgName: session?.currentOrganization?.name,
            } as POSTHOG_EVENT_DATA,
          );
        });
    }
    return {};
  }
}
